import styled from '@emotion/styled';

interface NotificationListItemType { 
    status: 'pending' | 'ongoing';
}

export const NotificationListItem = styled('div', { label: 'NotificationListItem' })<NotificationListItemType>`
    padding: 12px;
    opacity: ${({ status }): string => status === 'pending' ? '1' : '.6'};
`;

export const NotificationsMenuBetsItemContainer = styled('div', { label: 'NotificationsMenuBetsItemContainer' })`
    margin-bottom: 8px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const ItemBetName = styled('span', { label: 'ItemBetName' })`
    display: block;
    margin-bottom: 4px;
    word-wrap: break-word;
`;

export const ItemBetTime = styled('span', { label: 'ItemBetTime' })`
    display: block;
    margin-bottom: 8px;
`;
interface NotificationListContainerType { 
    isOpen: boolean;
}

export const NotificationListContainer = styled('div', { label: 'NotificationListContainer' })<NotificationListContainerType>`
    display: ${({ isOpen }): string => isOpen ? 'block' : 'none'};
    height: 100%;
    overflow-y: auto;
`;
